// extracted by mini-css-extract-plugin
module.exports = {"root":"root-2qX9nlPtn_","centered":"centered-CprUo1cvsZ"};